import { LocationData } from './types';

export enum LocationSource {
  Account = 'account',
  Config = 'config',
  CVNAID = 'cvnaid',
  Default = 'default',
  Ipaddress = 'ipaddress',
  Modal = 'modal',
  Param = 'param',
  Unknown = 'unknown',
  UtmLocation = 'utm_location',
  Vanity = 'vanity'
}

export type ValidLocationSource = Exclude<
  LocationSource,
  LocationSource.Unknown
>;

export const VALID_LOCATION_SOURCE_SET: ReadonlySet<string> = new Set(
  Object.values(LocationSource).filter(
    (v): v is ValidLocationSource =>
      typeof v === 'string' && v !== LocationSource.Unknown
  )
);

export enum CookieNames {
  City = 'CVCurrentCity',
  MerchHasLoggedIn = 'MerchHasLoggedIn',
  Source = 'CVCurrentSource',
  State = 'CVCurrentState',
  Zip = 'CVCurrentZip'
}

export const DefaultLocation: LocationData = {
  accuracyRadius: undefined,
  city: 'Atlanta',
  ipAddress: '',
  isFromCookies: false,
  state: 'GA',
  zip: '30303'
};

export const TwoWeeks = 1209600;
